import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

export default ({ roles, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (roles.loading) {
      return "is Loading";
    }
    if (isEmpty(roles.data)) {
      return <p className="is-size-2 has-text-centered has-text-grey">Found Nothing</p>;
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Slug</th>
            <th>Created at</th>
            <th>Updated at</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {roles.data.map(role => (
            <tr key={role.id}>
              <td>
                <a>{role.id}</a>
              </td>
              <td>{role.name}</td>
              <td>{role.slug}</td>
              <td>{role.created_at}</td>
              <td>{role.updated_at}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link to={`/roles/${role.id}/edit`} className="button  is-link is-small">
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(role.id)}
                    to={`/roles/${role.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Role/Index/Table.js